"use strict";

var transform = require('lodash/transform');

var isObject = require('lodash/isObject');

var isEqual = require('lodash/isEqual');
/**
     * Deep diff between two objects, using lodash.
     *
     * @see https://gist.github.com/Yimiprod/7ee176597fef230d1451.
     *
     * @memberof! Pricing
     * @param  {Object} object Object compared
     * @param  {Object} base   Object to compare with
     * @return {Object}        Return a new object who represent the diff
     */


function difference(outer_object, outer_base) {
  function changes(object, base) {
    var acc = {};
    transform(object, function (result, value, key) {
      acc = result;

      if (!isEqual(value, base[key])) {
        acc[key] = isObject(value) && isObject(base[key]) ? changes(value, base[key]) : value;
      }
    });
    return acc;
  }

  return changes(outer_object, outer_base);
}

module.exports = difference;